import { useEffect, useRef } from "react";
import type { FieldValues, UseFormTrigger } from "react-hook-form";

/**
 * Re-runs RHF validation when the language changes so error copy stays in
 * sync. Skips the mount effect.
 */
export function useRevalidateOnLocaleChange<TFieldValues extends FieldValues>(
  locale: string,
  trigger: UseFormTrigger<TFieldValues>,
): void {
  const validationLocaleRef = useRef(locale);

  useEffect(() => {
    if (validationLocaleRef.current === locale) {
      return; // skip re-validation if locale hasn't changed
    }

    validationLocaleRef.current = locale;
    void trigger(); // re-validate so error messages update to the new language
  }, [locale, trigger]);
}
